<div class="login">
  <form class="login-wrapper" autocomplete="off" [formGroup]="form" (submit)="auth()">
    <div class="header-form">
      <div class="logo-box">
        <img src="assets/img/logo-mini.svg" class="logo" alt="">
      </div>
    </div>
    <div class="field-list">
      <div class="field">
        <div class="caption">Номер личной карты</div>
        <div class="field-input">
          <ui-input type="text" placeholder="Номер личной карты" formControlName="CardNumber"></ui-input>
        </div>
      </div>
      <div class="field">
        <div class="caption">Пин-код личной карты</div>
        <div class="field-input">
          <ui-input-password placeholder="Пин-код личной карты" formControlName="ConvictedPassword"></ui-input-password>
        </div>
      </div>
    </div>
    <button nz-button nzType="primary" [disabled]="processing" type="submit">Войти</button>
    <div class="error error-server" *ngIf="serverError">{{this.serverError}}</div>
  </form>
</div>
